export default "__VITE_ASSET__C99qpd$S__"